import {
  Tooltip,
  ActionIcon,
  useMantineTheme,
  rem,
  Popover,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useState } from "react";
import { InfoTooltipIcon } from "../svg/InfoTooltopIcon";

export function InfoTooltip({ label, size }: { label: string; size: number }) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery("(pointer: coarse)");
  const [opened, setOpened] = useState(false);

  const commonStyles: React.CSSProperties = {
    backgroundColor: theme.colors.gray[1],
    color: theme.colors.dark[7],
    fontSize: rem(14),
    padding: `${rem(4)} ${rem(8)}`,
    borderRadius: rem(4),
    boxShadow: theme.shadows.sm,
    maxWidth: isMobile ? rem(340) : rem(500),
    wordWrap: "break-word" as "break-word",
    whiteSpace: "normal",
  };

  const icon = (
    <ActionIcon
      variant="transparent"
      style={{
        borderRadius: "50%",
        width: size + 3,
        height: size + 3,
        pointerEvents: "all",
      }}
      onClick={() => {
        if (isMobile) setOpened((o) => !o);
      }}
      aria-label="Інформація"
      tabIndex={0}
    >
      <InfoTooltipIcon size={size} />
    </ActionIcon>
  );

  if (isMobile) {
    return (
      <Popover
        opened={opened}
        onChange={setOpened}
        position="bottom"
        offset={6}
        withArrow
        zIndex={302}
        styles={{
          dropdown: commonStyles,
          arrow: { backgroundColor: theme.colors.gray[1] },
        }}
      >
        <Popover.Target>{icon}</Popover.Target>
        <Popover.Dropdown>{label}</Popover.Dropdown>
      </Popover>
    );
  }

  return (
    <Tooltip
      zIndex={302}
      label={label}
      withArrow
      transitionProps={{ duration: 100, transition: "fade" }}
      arrowSize={6}
      arrowOffset={8}
      position="top"
      offset={6}
      styles={{
        tooltip: commonStyles,
        arrow: { backgroundColor: theme.colors.gray[1] },
      }}
    >
      {icon}
    </Tooltip>
  );
}
